import React from "react";
import NavBar from "../elements/NavBar";

function Header() {
  return (
    <header className="site-header">
      <NavBar />
    </header>
  );
}

export default Header;
